import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

// create slice

const postForm = {
  title: "",
  description: "",
  files: [],
  status: true,
};
const name = "post";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const postFormAction = { ...slice.actions, ...extraActions };
export const postformReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    postForm: postForm,
    getPostFormListResponse: {}, //event list for grid
    createPostFormResponse: {},
    updatePostFormResponse: {},
    deletePostFormResponse: {},
    loading: false,
  };
}

function createReducers() {
  return {
    updateForm,
    resetForm,
  };
  function updateForm(state, action) {
    state.postForm = {
      ...state.postForm,
      ...action.payload,
    };
  }
  function resetForm(state) {
    state.postForm = postForm;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getPostFormList: getPostFormList(),
    createPostForm: createPostForm(),
    updatePostForm: updatePostForm(),
    togglePostForm: togglePostForm(),
    deletePost: deletePost(),
  };

  function getPostFormList() {
    return createAsyncThunk(
      `${name}/getPostFormList`,
      async (searchParams) =>
        await fetchWrapper.get(`${baseUrl}/post${searchParams}`)
    );
  }

  function createPostForm() {
    return createAsyncThunk(`${name}/createPostForm`, async (payload) => {
      const committeeID = payload.get("committee") || 0;
      return await fetchWrapper.post(
        `${baseUrl}/post?committee=${committeeID}`,
        payload
      );
    });
  }

  function updatePostForm() {
    return createAsyncThunk(`${name}/updatePostForm`, async (payload) => {
      const postID = payload.get("postID") || 0;
      return await fetchWrapper.patch(`${baseUrl}/post/${postID}`, payload);
    });
  }

  function togglePostForm() {
    return createAsyncThunk(
      `${name}/togglePostForm`,
      async ({ id, status }) => {
        return await fetchWrapper.patch(`${baseUrl}/post/${id}/toggle-status`);
      }
    );
  }

  function deletePost() {
    return createAsyncThunk(`${name}/deletePost`, async (id) => {
      return await fetchWrapper.delete(`${baseUrl}/post/${id}`);
    });
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getPostFormList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getPostFormList.fulfilled, (state, action) => {
      state.loading = false;
      state.getPostFormListResponse = action.payload;
    })
    .addCase(extraActions.getPostFormList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //ceate post form
    .addCase(extraActions.createPostForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createPostForm.fulfilled, (state, action) => {
      state.createEventResponse = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.createPostForm.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //update post form
    .addCase(extraActions.updatePostForm.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.updatePostForm.fulfilled, (state, action) => {
      state.loading = false;
      state.updateEventResponse = action.payload;
    })
    .addCase(extraActions.updatePostForm.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })

    //togglePostForm
    .addCase(extraActions.togglePostForm.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.togglePostForm.fulfilled, (state, action) => {
      state.loading = false;
      state.deletePostFormResponse = action.payload;
    })
    .addCase(extraActions.togglePostForm.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    });
}
